import ProductMixRevenueBreakdown from "@shared-containers/ProductMixRevenueBreakdown";
import RevenueBreakdownTable from "@shared-containers/RevenueBreakdownTable";

import { DEVICE, useWindowSizeChanged } from "@hooks/DeviceSize";
import { CustomCardWrapper, RevenueDashboardMainWrapper } from "./styles";
import TotalSales from "./TotalSales";

const RevenueDashBoard = () => {
  const device = useWindowSizeChanged();
  const isDesktop = device === DEVICE.DESKTOP;
  return (
    <RevenueDashboardMainWrapper isDesktop={isDesktop}>
      <CustomCardWrapper isDesktop={isDesktop}>
        <TotalSales />
      </CustomCardWrapper>
      <CustomCardWrapper isDesktop={isDesktop}>
        <RevenueBreakdownTable pagination={false} />
      </CustomCardWrapper>
      <CustomCardWrapper isDesktop={isDesktop} minHeight="600px">
        <ProductMixRevenueBreakdown />
      </CustomCardWrapper>
    </RevenueDashboardMainWrapper>
  );
};

export default RevenueDashBoard;
